import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <h2>Our People</h2>Our people are integral to our success and are the heartbeat of our
        business. They deliver on a daily basis to enable the JD Group to meet and exceed
        expectations. We currently have more than 50,000 people within our business. Our aim is to
        attract, develop and engage committed and talented people so that they choose to grow with
        the Group throughout their careers.<h2>Global Opportunities</h2>The JD Group is currently
        looking for the brightest talent to join the team in a variety of Group roles situated at
        our Head Office, Distribution Centre and across our Retail Stores.
        <br />
        <br />
        As our business continues to expand globally, we continue to search for driven and talented
        individuals who love what they do and are passionate about taking the next step in their
        career.
        <br />
        <br />
        We respect each member of our team and everyone is encouraged to put forward their ideas,
        regardless of how big or small, as dynamic thinking is what drives this business to be
        competitive. Our brand ethos is all about innovation, creativity and competitiveness and
        therefore, we love to hear from people who share those values.
        <br />
        <br />
        We inspire our people to reach for the highest levels of performance. All employees are
        highly skilled, self-motivated and in constant pursuit of perfection when delivering
        business objectives. Opportunities to progress arise quickly for those people with the right
        qualities and ambition.
        <br />
        <br />
        We encourage our people to constantly seek ways to improve our performance. This means
        challenging the way in which we merchandise, sell product and manage the business and being
        forward-thinking in suggesting logical yet unique solutions. Problems are solved and
        opportunities seized by people working together from all levels of the organisation.
        <br />
        <br />
        If you are interested in joining the JD Group, please access the link below to find out more
        information regarding current employment opportunities.
        <br />
        <br />
        <a
            className="button"
            target="_blank"
            rel="noopener noreferrer"
            href="https://jdfashionplc.team.careers/"
        >
            View Retail, Head Office &amp; Distribution Facility Positions
        </a>
        <a
            className="button"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/jd-sports-fashion-plc"
        >
            Find us on LinkedIn
        </a>
        <br />
        <br />
        The Company is committed to being transparent about how it collects and uses your data and
        to meeting its data protection obligations, for further information, please read our{' '}
        <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            title="Job Applicant Privacy Notics"
            href="https://files.jdplc.com/pdf/job-applicant-privacy-notice.pdf"
        >
            Job Applicant Privacy Notice
        </a>{' '}
        for more information.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/careers.jpg',
    body: Body,
};
